/** Stable string id for ObjectId / populated ref / string */
export const normalizeId = (v: any): string => {
  if (v == null || v === "") return "";
  if (typeof v === "object" && v !== null && "_id" in v) {
    return String((v as { _id: unknown })._id ?? "");
  }
  return String(v);
};

export const normProfile = (p: unknown) =>
  String(p ?? "").trim().toLowerCase();

/**
 * Team user (type 3) whose profile is "User" — branch/city/assign are locked.
 * Prefer session (signinuser): Redux `user` may be stale or still loading.
 */
export const isLockedRegularTeamUser = (
  signinuser: { UserType?: number; UserProfile?: string } | null | undefined,
  profileUser: { UserProfile?: string } | null | undefined,
) => {
  if (!signinuser || signinuser.UserType !== 3) return false;
  const sp = normProfile(signinuser.UserProfile);
  const up = normProfile(profileUser?.UserProfile);
  if (sp === "manager") return false;
  if (sp === "user") return true;
  if (!sp && up === "user") return true;
  return false;
};

/** Only team Managers should have city/assign cleared when branch/city changes */
export const isTeamManagerTeamUser = (
  signinuser: { UserType?: number; UserProfile?: string } | null | undefined,
  profileUser: { UserProfile?: string } | null | undefined,
) => {
  if (!signinuser || signinuser.UserType !== 3) return false;
  const sp = normProfile(signinuser.UserProfile);
  const up = normProfile(profileUser?.UserProfile);
  return sp === "manager" || (!sp && up === "manager");
};
